import systemSettingHandler from "../../services/SystemSetting";

export default {
    async loadSettings({commit, dispatch}, payload) {
        const {data} = await systemSettingHandler.get(payload);

        commit('SET_SETTINGS', data);
    },
    async updateSettings({commit, dispatch}, payload) {
        return systemSettingHandler.update(payload);
    },
}
